import { useContext } from "react";
import { AdminContext } from "../context/AdminContext";

export function UseAdmin() {
  const context = useContext(AdminContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
